import React, { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import './common.css'
import { Link } from 'react-router-dom'

import i18n from 'i18next';
import { useTranslation, initReactI18next } from 'react-i18next';

const Header = () => {
  const {shop} = useParams();
  const path = window.location.pathname;

  const lang = localStorage.getItem('language')
  const [language, setLanguage] = useState(lang ? lang : 'ta')
  const { t } = useTranslation();

  useEffect(() => {
    // cookieに保存
    localStorage.setItem('language', language)

    if (language == 'ta') {
      i18n.changeLanguage('ta', (err, t) => {
        if (err) return console.log('something went wrong loading', err);
        t('key'); // -> same as i18next.t
      });
    } else if (language == 'ja') {
      i18n.changeLanguage('ja', (err, t) => {
        if (err) return console.log('something went wrong loading', err);
        t('key'); // -> same as i18next.t
      });
    } else if (language == 'en') {
      i18n.changeLanguage('en', (err, t) => {
        if (err) return console.log('something went wrong loading', err);
        t('key'); // -> same as i18next.t
      });
    }
  },[language])



  return (
    <>
      <div className="header">
      {path != ('/' + shop + '/shop-payment-coupon')  &&
        <>
        <div className="header-title">ORIPAL</div>
        <div className="user-icon">
              <Link to={"/" + shop + "/shop"}>
                <img className="user-icon-image" src="/img/user.svg" />
              </Link>
        </div>
        <div className="language-change">
          <select className="language-select" value={language} onChange={(e) => setLanguage(e.target.value)}>
            <option value="ta">繁体</option>
            <option value="ja">日本語</option>
            <option value="en">English</option>
          </select>
        </div>
        </>
      }
      </div>
    </>
  )
}

export default Header